module.exports = __webpack_public_path__ + "static/media/default.a863829c.svg";